import { MAP_TYPES } from '@deck.gl/carto';

const HOUSEHOLDPOPULATIONDENSITYACRES_SOURCE_ID = 'householdPopulationDensityAcresSource';

const source = {
  id: HOUSEHOLDPOPULATIONDENSITYACRES_SOURCE_ID,
  type: MAP_TYPES.TILESET,
  connection: 'bmpo-smartmetro-09142026',
  data: 'us-con-gcp-npr-0000424-011325.bmpo_curated_dev.urbansim_base_scenario_05_17_tileset',
};

export default source;
